import { useEffect } from 'react';
import {
  silurian_cones_source_id,
  silurian_points_source_id,
  silurian_paths_source_id,
  processSilurianProjectionData,
} from './mapEventsEffects/configureSilurianProjectionLayers';
import dayjs from 'dayjs';
import { MapboxMap } from 'react-map-gl';
import { GeoJSONSource } from 'mapbox-gl';
import { useSilurianProjectionLayer } from '../mapHooks/useSilurianProjectionLayer';
import { useSilurianProjectionsFlag } from 'utils/featureFlags';
import { SilurianProjectionResponse } from './mapEventsEffects/mapEventsEffectTypes';

const useUpdateSilurianProjectionLayer = (
  map: React.MutableRefObject<MapboxMap | undefined>,
  selectedDatetime: dayjs.Dayjs
) => {
  const { mutate: fetchSilurianProjectionData } = useSilurianProjectionLayer();
  const silurianProjectionActive = useSilurianProjectionsFlag();

  useEffect(() => {
    if (!silurianProjectionActive) return;

    const silurianSourceIds = [
      silurian_cones_source_id,
      silurian_points_source_id,
      silurian_paths_source_id,
    ] as const;

    const hasSilurianSources = silurianSourceIds.some((sourceId) =>
      map.current?.getSource(sourceId)
    );

    if (hasSilurianSources) {
      fetchSilurianProjectionData(selectedDatetime as any, {
        onSuccess: (newData: SilurianProjectionResponse[]) => {
          const processedData = processSilurianProjectionData(newData);

          if (map.current?.getSource(silurian_cones_source_id)) {
            const conesSource = map.current.getSource(
              silurian_cones_source_id
            ) as GeoJSONSource;
            conesSource.setData({
              type: 'FeatureCollection',
              features: processedData.silurianConesFeatures as any,
            });
          }

          if (map.current?.getSource(silurian_points_source_id)) {
            const pointsSource = map.current.getSource(
              silurian_points_source_id
            ) as GeoJSONSource;
            pointsSource.setData({
              type: 'FeatureCollection',
              features: processedData.silurianPointsFeatures as any,
            });
          }

          if (map.current?.getSource(silurian_paths_source_id)) {
            const pathsSource = map.current.getSource(
              silurian_paths_source_id
            ) as GeoJSONSource;
            pathsSource.setData({
              type: 'FeatureCollection',
              features: processedData.silurianPathsFeatures as any,
            });
          }
        },
      });
    }
  }, [
    map,
    selectedDatetime,
    fetchSilurianProjectionData,
    silurianProjectionActive,
  ]);
};

export default useUpdateSilurianProjectionLayer;
